/**
 * Neutraliza fórmula numa célula de CSV (CSV injection).
 *
 * Origem: #795 — 2026-10-07 15:30 +0200 (auditoria 2º nível, "o CSV não
 * neutraliza fórmula").
 *
 * Por quê: planilha (Excel, Sheets, LibreOffice) executa como fórmula a
 * célula que começa com `= + - @ TAB CR`. Os CSVs exportados levam texto
 * controlado por terceiros (`lastError` e URL do endpoint do parceiro,
 * motivo de cobrança, nome digitado por membro) — um `=HYPERLINK(...)` vira
 * link/ação na máquina de quem abre. Prefixar `'` faz a planilha mostrar o
 * valor como texto (recomendação OWASP). Número puro (`-12`, `+3.5`, `1,5`)
 * não é fórmula e passa intacto, para não virar texto numa coluna de valor.
 *
 * Contrato: puro; recebe o texto JÁ convertido em string e devolve o texto a
 * ser escapado (aspas do RFC 4180 continuam com quem chama).
 *
 * Usado por: portal `apps/developers` (`WebhookEventsPage.tsx`, Event log),
 * admin (`features/shared/csvStream.ts`), Functions
 * (`admin/exportAuditBilling.ts`). Mesma regra à mão no Android
 * (`ActivityCsvExport.kt`, `csvCell`) e no iOS (`ActivityCsv.swift`).
 */
export function neutralizeCsvFormula(value: string): string {
  if (value === '' || !FORMULA_TRIGGERS.has(value.charAt(0))) return value;
  return PLAIN_NUMBER.test(value) ? value : `'${value}`;
}

/** Primeiro caractere que planilha lê como fórmula. */
const FORMULA_TRIGGERS: ReadonlySet<string> = new Set(['=', '+', '-', '@', '\t', '\r']);

/** Número puro — não é fórmula. */
const PLAIN_NUMBER = /^[+-]?\d+([.,]\d+)?$/;
